import { io } from "socket.io-client";

let socket;

// The URL of your SEPARATE chat server
const CHAT_SERVER_URL =
  process.env.REACT_APP_CHAT_URL || "http://localhost:4001";

export const initiateSocketConnection = (token) => {
  if (socket?.connected) return;

  socket = io(CHAT_SERVER_URL, {
    transports: ["websocket"],
    auth: {
      token: token, // This goes to your JWT middleware in chat-socket.js
    },
    // For 25k users, these settings help stability
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  console.log("Connecting to Chat Server...");
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    console.log("Chat Disconnected");
  }
};

export const joinChatRoom = (sessionId) => {
  if (socket) {
    console.log(sessionId);

    socket.emit("joinRoom", { sessionId });
  }
};

export const subscribeToMessages = (callback) => {
  if (!socket) return;

  // Listen for real-time messages
  socket.on("new_message", (data) => {
    callback(data, "message"); // false = not history
  });

  // Listen for the initial 100 messages from Redis
  socket.on("chat_history", (history) => {
    callback(history, "history"); // true = is history
  });

  socket.on("error_msg", (msg) => {
    if (
      msg === "Session ended" ||
      msg === "The live chat for this session has ended."
    ) {
      callback(msg, "session_ended");
    }
    console.error("Chat Error:", msg);
  });

  // ✅ LISTEN FOR chat_ended EVENT
  socket.on("chat_ended", (msg) => {
    console.log("CHAT ENDED:", msg);

    callback(msg, "chat_ended");
  });
};

export const sendMessage = (sessionId, text) => {
  if (socket) {
    console.log(text);

    socket.emit("send_message", { sessionId, text });
  }
};
